export enum URL_PAGE {
  HOME = 'home',
  BIENVENUE = 'bienvenue',
  AUTOLOGIN = 'autologin',
  UNAUTHORIZED = 'unauthorized',
}
